import * as React from 'react';
import { createScriptTag, injectTags } from '@grandvisionhq/utils';
import { RecaptchaContext } from './RecaptchaProvider.js';

const useRecaptchaContext = ()=>React.useContext(RecaptchaContext)
;
const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js';
const useRecaptcha = (options)=>{
    const { settings  } = useRecaptchaContext();
    const countRef = React.useRef(0);
    const TRY_INTERVAL = 80;
    const MAX_TRY_COUNT = 25;
    React.useEffect(()=>{
        if (!settings) {
            return;
        }
        const script = createScriptTag({
            async: true,
            src: `${RECAPTCHA_SCRIPT_SRC}?render=${settings.siteKey}`
        });
        injectTags([
            script
        ]);
    }, [
        settings
    ]);
    function checkScript(cb) {
        // check if script is being loaded
        if (typeof window.grecaptcha === 'undefined') {
            countRef.current += 1;
            if (countRef.current > MAX_TRY_COUNT) {
                return cb(new Error('Recaptcha not correctly initialised.'));
            }
            return setTimeout(()=>{
                checkScript(cb);
            }, TRY_INTERVAL);
        }
        cb(null);
    }
    const getToken = React.useCallback(()=>{
        return new Promise((resolve, reject)=>{
            checkScript((error)=>{
                if (error) {
                    return reject(error);
                }
                window.grecaptcha.ready(()=>{
                    const action = (options === null || options === void 0 ? void 0 : options.action) || 'form';
                    window.grecaptcha.execute(settings.siteKey, {
                        action
                    }).then(resolve).catch(reject);
                });
            });
        });
    }, []);
    return {
        getToken
    };
};

export { useRecaptcha };
//# sourceMappingURL=useRecaptcha.js.map
